export const getActorName = (actor: { data?: { name?: string } }) => {
  if (actor?.data?.name) {
    return actor?.data?.name;
  }

  if (typeof actor === 'string') {
    return actor;
  }

  return 'Unknown';
};
